import {ChangeDetectionStrategy, Component, computed, input, linkedSignal} from "@angular/core";
import {FontAwesomeCode} from "@models";
import {MatIcon} from "@angular/material/icon";
import {NgClass} from "@angular/common";

@Component({
	selector: "sim-animated-material-icon",
	templateUrl: "./animated-material-icon.component.html",
	styleUrls: ["./animated-material-icon.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [MatIcon, NgClass],
})
export class AnimatedMaterialIconComponent {
	// I/O
	public readonly startIcon = input.required<FontAwesomeCode>();
	public readonly endIcon = input.required<FontAwesomeCode>();
	public readonly triggerInput = input.required<boolean>({alias: "trigger"});
	public readonly biggerFAIcon = input<boolean>(false);

	// Properties
	protected readonly trigger = linkedSignal<boolean>(() => this.triggerInput());
	protected readonly classes = computed<{[p: string]: unknown}>(() =>
		this.computeClasses(this.trigger(), this.endIcon(), this.startIcon()),
	);

	private computeClasses(trigger: boolean, endIcon: FontAwesomeCode, startIcon: FontAwesomeCode) {
		const result = {} as {[p: string]: unknown};
		result["animate"] = trigger;
		if (endIcon.themeColor) {
			result[endIcon.themeColor] = trigger;
		}
		if (startIcon.themeColor) {
			result[startIcon.themeColor] = !trigger;
		}
		return result;
	}
}
